import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "emp-content-wrapper" }
const _hoisted_2 = { class: "emp-bottom-nav" }
const _hoisted_3 = { class: "nav-icon-wrapper" }
const _hoisted_4 = { class: "nav-label" }

import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmpLayout',
  setup(__props) {

const route = useRoute();

// 사원 전용 메뉴 (센터장/관리자용보다 제한적)
const navItems = [
  {
    path: '/emp/schedule',
    label: '일정',
    icon: 'mdi-calendar',
    activeColor: '#059669'
  },
  {
    path: '/emp/payslip',
    label: '급여',
    icon: 'mdi-currency-krw',
    activeColor: '#059669'
  },
  {
    path: '/emp/home',
    label: '홈',
    icon: 'mdi-home',
    activeColor: '#059669'
  },
  {
    path: '/emp/documents',
    label: '문서함',
    icon: 'mdi-folder-file',
    activeColor: '#059669'
  },
  {
    path: '/emp/more',
    label: '더보기',
    icon: 'mdi-dots-horizontal',
    activeColor: '#059669'
  }
];

const isActiveRoute = (path: string): boolean => {
  // 더보기 탭은 관련 하위 페이지들도 활성화
  if (path === '/emp/more') {
    return route.path === '/emp/more' || 
           route.path === '/emp/myinfo' || 
           route.path === '/emp/settings' ||
           route.path.startsWith('/emp/notice');
  }
  return route.path === path || route.path.startsWith(path + '/');
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "emp-layout" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
          return _createVNode(_component_router_link, {
            key: item.path,
            to: item.path,
            class: _normalizeClass(["nav-item", { active: isActiveRoute(item.path) }])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_icon, {
                  size: 24,
                  color: isActiveRoute(item.path) ? item.activeColor : '#9ca3af'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.icon), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ]),
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"])
        }), 64))
      ])
    ]),
    _: 3
  }))
}
}

})